<template>
  <v-container
      fluid
      pa-1
  >
    <v-layout
        row
        wrap
        pa-0
        class="align-start"
    >

      <vue-plotly watchShallow="true" :data="data" :layout="layout" :options="options"></vue-plotly>

    </v-layout>
  </v-container>
</template>

<script>

import VuePlotly from '@statnett/vue-plotly'

export default {
  name: "PieChart",
  components: {
    VuePlotly
  },
  props: ["items"],
  data() {
    return {
      options: {
        displayModeBar: false,
        scrollZoom: false,
        responsive: true,
      },
      data: [
        {
          labels: [],
          values: [],
          type: 'pie',
          textinfo: "label+percent",
        }
      ],
      layout: {
        title: {
          text: '',
          font: {
            family: 'GothamRounded-Book',
            size: 24,
            color: '#ffffff'
          }
        },
        height: 600,
        // automargin: true,

        margin: { t: 25, r: 25, l: -20, b: 25 },
        responsive: true,
        paper_bgcolor: 'rgba(0,0,0,0)',
        legend: {
          bordercolor:"Black",
          borderwidth:2,
          //orientation: "h",
          //itemclick:false,
          itemdoubleclick: false,
          xanchor: "left",
          font: {
            family: 'GothamRounded-Book',
            size: 12,
          }
        },
      }
    }
  },
  created() {
    this.build();
  },

  methods: {
    build() {
      this.data[0].labels = this.items.labels;
      this.data[0].values = this.items.values;
    }
  },
};
</script>

<style lang="scss">

</style>
